// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-other-names-table {
  margin-bottom: 10px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
}

.table-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.add-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.add-btn:hover {
  background: #218838;
}

.empty-state {
  text-align: center;
  padding: 30px 20px;
  border: 2px dashed #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
}

.empty-state p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
}

/* Entry Cards Container */
.entries-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Entry Card Styling */
.entry-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.entry-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.entry-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.entry-number {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entry-badge {
  background: #007bff;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.entry-number h5 {
  margin: 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}

.entry-form {
  padding: 16px;
}

/* Form Rows */
.form-row {
  display: grid;
  gap: 12px;
  margin-bottom: 12px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-row-1 {
  grid-template-columns: 1fr 1fr;
}

/* Field Groups */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-group label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 4px;
  line-height: 1.3;
  min-height: 18px;
  white-space: nowrap;
  overflow: visible;
}

.field-group input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fff;
  box-sizing: border-box;
}

.field-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.field-group input::placeholder {
  color: #adb5bd;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-btn:hover {
  background: #c82333;
}

.table-footer {
  margin-top: 15px;
  text-align: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.hint-text {
  margin: 0 0 10px 0;
  color: #666;
  font-size: 14px;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

/* Table Footer */
.table-footer {
  margin-top: 15px;
  text-align: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  
  .add-btn {
    width: 100%;
  }
  
  .form-row-1 {
    grid-template-columns: 1fr;
  }
  
  .entry-form {
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .entry-card {
    margin-bottom: 12px;
  }
  
  .entry-header {
    padding: 10px 12px;
  }
  
  .field-group input {
    padding: 6px 10px;
    font-size: 13px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DynamicOtherNamesTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".dynamic-other-names-table {\n  margin-bottom: 10px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 10px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.table-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.add-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.add-btn:hover {\n  background: #218838;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 30px 20px;\n  border: 2px dashed #e9ecef;\n  border-radius: 8px;\n  background: #f8f9fa;\n}\n\n.empty-state p {\n  margin: 0 0 15px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Entry Cards Container */\n.entries-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Entry Card Styling */\n.entry-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 0;\n  margin-bottom: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.entry-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n.entry-header {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  padding: 12px 16px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.entry-number {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entry-badge {\n  background: #007bff;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.entry-number h5 {\n  margin: 0;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.entry-form {\n  padding: 16px;\n}\n\n/* Form Rows */\n.form-row {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n.form-row-1 {\n  grid-template-columns: 1fr 1fr;\n}\n\n/* Field Groups */\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 4px;\n  line-height: 1.3;\n  min-height: 18px;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.field-group input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.field-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.field-group input::placeholder {\n  color: #adb5bd;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n.table-footer {\n  margin-top: 15px;\n  text-align: center;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.hint-text {\n  margin: 0 0 10px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n}\n\n/* Table Footer */\n.table-footer {\n  margin-top: 15px;\n  text-align: center;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n  \n  .add-btn {\n    width: 100%;\n  }\n  \n  .form-row-1 {\n    grid-template-columns: 1fr;\n  }\n  \n  .entry-form {\n    padding: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .entry-card {\n    margin-bottom: 12px;\n  }\n  \n  .entry-header {\n    padding: 10px 12px;\n  }\n  \n  .field-group input {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
